export interface IBankingReviewTerminology {
    isUs: boolean;
    routingLabel: string;
    accountLabel: string;
    selectionError: string;
    routingEmailSentence: (dashboardLinkHtml: string) => string;
    accountEmailSentence: (dashboardLinkHtml: string) => string;
    routingReviewAlert: string;
    accountReviewAlert: string;
}

export function getBankingReviewTerminology(country: number, isUsBank?: boolean | null): IBankingReviewTerminology {
    const isUs = isUsBank != null ? isUsBank === true : country === 1;
    if (isUs) {
        return {
            isUs: true,
            routingLabel: 'ACH routing number',
            accountLabel: 'ACH account number',
            selectionError: 'Select at least one: ACH routing number or ACH account number.',
            routingEmailSentence: (dashboardLinkHtml: string) =>
                `The ACH routing number you supplied is incorrect or needs to be updated. Please correct your routing number ${dashboardLinkHtml}.`,
            accountEmailSentence: (dashboardLinkHtml: string) =>
                `The ACH account number you supplied is incorrect or needs to be updated. Please correct your account number ${dashboardLinkHtml}.`,
            routingReviewAlert: 'Donor must update ACH routing number. ',
            accountReviewAlert: 'Donor must update ACH account number.',
        };
    }
    return {
        isUs: false,
        routingLabel: 'SWIFT number',
        accountLabel: 'International account number',
        selectionError: 'Select at least one: SWIFT number or international account number.',
        routingEmailSentence: (dashboardLinkHtml: string) =>
            `The SWIFT number you supplied is incorrect or needs to be updated. Please correct your SWIFT number ${dashboardLinkHtml}.`,
        accountEmailSentence: (dashboardLinkHtml: string) =>
            `The international account number you supplied is incorrect or needs to be updated. Please correct your international account number ${dashboardLinkHtml}.`,
        routingReviewAlert: 'Donor must update SWIFT number. ',
        accountReviewAlert: 'Donor must update international account number.',
    };
}
